export function maskCpf(value, cutExess = true) {
    let maskedValue = value.replace(/\D/g, '');
    if (cutExess) {
        maskedValue = maskedValue.slice(0, 11);
    }
    maskedValue = maskedValue
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return maskedValue;
}
export function unmaskCpf(value) {
    return value.replace(/\D/g, '');
}
export function maskCpfHidden(value) {
    const valueToHide = value.includes('*') ? value : value.replace(/\D/g, '');
    return `***.${valueToHide.substring(3, 6)}.${valueToHide.substring(6, 9)}-**`;
}
